module.exports = __webpack_public_path__ + "img/contact1.412af8ba.png";